import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const addItemsSlice = createSlice({
	name: 'addItems',
	initialState,
	reducers: {
		setAddItems: (state, action) => {
			return action.payload;
		}
	}
});

export const { setAddItems } = addItemsSlice.actions;
export default addItemsSlice.reducer;
